import { render, staticRenderFns } from "./ShorexInfoPopup.vue?vue&type=template&id=1151fe41&scoped=true"
import script from "./ShorexInfoPopup.vue?vue&type=script&lang=js"
export * from "./ShorexInfoPopup.vue?vue&type=script&lang=js"
import style0 from "./ShorexInfoPopup.vue?vue&type=style&index=0&id=1151fe41&prod&lang=less&scoped=true"
import style1 from "./ShorexInfoPopup.vue?vue&type=style&index=1&id=1151fe41&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1151fe41",
  null
  
)

export default component.exports